import React from "react";
import MenuFeatures from "svgs/menu-features.svg";
import AppStore from "svgs/menu-appstore-download.svg";
import PlayStore from "svgs/menu-playstore-download.svg";

const Solutions = [
  // {
  //   product: "Rails",
  //   brief:
  //     "Create your fintech innovations with a partner that provides a secure and robust API infrastructure to scale with.",
  //   features: [
  //     {
  //       title: "E-wallets",
  //       about:
  //         "Provide your consumers with a secure digital purse for easy payment. Through our API, you can simply validate all created user accounts.",
  //       icon: <MenuFeatures />,
  //       url: "/solutions/rails/#ewallet",
  //     },
  //     {
  //       title: "Virtual Accounts",
  //       about:
  //         "Streamline various financial transactions through generated static or dynamic accounts. With an API connection, you can enjoy automated periodic payments.",
  //       icon: <MenuFeatures />,
  //       url: "/solutions/rails/#virtual-account",
  //     },
  //     {
  //       title: "Card Services",
  //       about:
  //         "Enhance your customers' payment experience by offering both physical and virtual cards for convenient transactions. Issue and manage cards with ease from a single platform.",
  //       icon: <MenuFeatures />,
  //       url: "/solutions/rails/#cards",
  //     },
  //   ],
  //   productLink: "/solutions/rails",
  //   isExternal: false,
  //   externalURL: "https://rails.parkway.ng",
  //   externalTitle: "Sign in to Rails",
  // },
  {
    product: "ReadyCash",
    brief:
      "Join the agents serving their community with financial and banking services while increasing your daily revenue.",
    features: [
      {
        title: "Agency Banking",
        about:
          "Provide your customers with services such as account opening, BVN registration, hospital collections, cash-in cash-out services and other value-added services using a mobile application or affordable POS device.",
        icon: <MenuFeatures />,
        url: "/solutions/readycash/#agency-banking",
      },
      {
        title: "Bills Payment",
        about:
          "Utilise various bill payment products and services to settle all your daily and recurring expenses such as electricity bills, airtime and data recharge, pay-TV subscription, WAEC and JAMB payment with a reliable application.",
        icon: <MenuFeatures />,
        url: "/solutions/readycash/#bills-payment",
      },
      {
        title: "Payment Collection",
        about:
          "Businesses can enhance their payment collection capabilities by integrating to our collection infrastructure. From subscriptions to ticket bookings, our platform ensures a smooth and secure payment collection process for all your essential services.",
        icon: <MenuFeatures />,
      },
    ],
    productLink: " https://www.readycash.com.ng/",
    isExternal: true,
    // appLink: [
    //   {
    //     appStore: "#",
    //     icon: <AppStore />,
    //   },
    //   {
    //     playStore: "#",
    //     icon: <PlayStore />,
    //   },
    // ],
  },
  {
    product: "Parkway Wallet",
    brief:
      "Send and receive money with a fast and secure mobile application without worries about delays or failed transactions.",
    features: [
      {
        title: "Send Money",
        about:
          "Enjoy zero charges and fast transfers to any bank you choose. With a few taps, you can settle all your payments with ease.",
        icon: <MenuFeatures />,
      },
      {
        title: "Receive Money",
        about:
          "Collect all your business and personal payments with a safe and secure digital wallet. You never have to worry about your money because it is in good hands.",
        icon: <MenuFeatures />,
      },
      {
        title: "Cards",
        about:
          "With a Parkway wallet card, you can settle your subscriptions and online payments with a reliable physical or virtual card.",
        icon: <MenuFeatures />,
      },
    ],
    productLink: "https://wallet.parkway.ng",
    isExternal: true,
    appLink: [
      {
        appStore: "https://apps.apple.com/us/app/parkway-wallet/id6451072719",
        icon: <AppStore />,
      },
      {
        playStore:
          "https://play.google.com/store/apps/details?id=com.parkway.yurwallet",
        icon: <PlayStore />,
      },
    ],
  },
  {
    product: "Central Billing System",
    brief:
      "Our secure billing system empowers you to effortlessly generate and process payments for various collections, including State revenue and Federal MDAs collections.",
    features: [
      {
        title: "E-Invoicing",
        about:
          "Experience the convenience of our dependable e-invoicing platform, designed to streamline your revenue payments with our effortless automated process.",
        icon: <MenuFeatures />,
      },
      {
        title: "Settlement",
        about:
          "Seamlessly handle complex payments to multiple financial institutions with our user-friendly solution, using preconfigured rules.",
        icon: <MenuFeatures />,
      },
    ],
    productLink: "https://cbsdemo.parkwayprojects.xyz/",
    isExternal: true,
  },
];

export { Solutions };
